import classNames from 'classnames';
import * as styles from './errorMessage.linaria';
function ErrorMessage({ id, errorMessage, className }) {
    if (!errorMessage)
        return null;
    return (<span id={`${id}_error`} role='alert' className={classNames([styles.style, className])}>
      {errorMessage}
    </span>);
}
ErrorMessage.defaultProps = {
    className: null,
};
export default ErrorMessage;
